/**
 * UranIA PA — Root route `/`.
 *
 * Copertina "le tre anime" — assorbe `/overview` (fusione A.4.1, "UranIA
 * PA — Riordino della mappa delle rotte" §4: "Due vetrine pubbliche
 * competono per la stessa visita"). `PublicLanding` (costellazione dei 4
 * pilastri) è stata rimossa, non solo scollegata — era la vetrina
 * perdente, tenerla in giro come componente morto non aveva senso.
 * `/overview` resta come redirect a `/` (`routes/overview.tsx`): i link
 * già circolati non si rompono.
 *
 * Smistamento per ruolo: vive sul segmento `(pubblico)` (`_pubblico.tsx`,
 * `guardiaPubblico()` in `lib/ruoli.ts` — Rilascio A passo A.1), così
 * vale per tutte le rotte pre-login, non solo la radice.
 */

import { createRoute } from '@tanstack/react-router';

import { OverviewPage } from '../features/overview/OverviewPage.tsx';
import { Route as PubblicoRoute } from './_pubblico.tsx';

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/',
  component: OverviewPage,
});
